import { action as apiAction } from 'api/Api'
import { setCompleted } from '../redux/checklistItems'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistItemId: number
  completed: boolean
}

const requestToggleChecklistItem = (payload: Payload) => async dispatch => {
  const { cardId, checklistItemId, completed } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCompleted({
    cardId,
    checklistItemId: checklistItemId,
    completed
  }))

  try {
    await apiAction(completed ? 'CompleteChecklistItem' : 'UncompleteChecklistItem', {
      id: checklistItemId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 301) { // CompletableCantChange
      throw error
    }
  }
}

export default requestToggleChecklistItem
